// Brand specific configuration
// This file is required for each brand
// Don't include any secrets here, they should be in the .env file

import { BaseBrandThemeConfig, BffBrandType } from '@shared-components-web';
const config: BrandThemeConfig = {
	...BaseBrandThemeConfig,
	name: 'Lovet',
	logo: {
		dark: 'https://images.ctfassets.net/m8zwsu9tyucg/6eLdygMaUQr4ohKZLkM3vP/71c1c7dc0c69b8ef4b1373fb8d39f525/Lovet_rgb_full_lock_up_pos_sm_no-padding.svg',
		light: 'https://images.ctfassets.net/m8zwsu9tyucg/4KkZLxLLdC7Oj8tGlCGxHs/b1c325a46cf773da74d15549dfe4ea65/Lovet_rgb_full_lock_up_neg_sm_no-padding.svg',
	},
	services: {
		prod: {
			...BaseBrandThemeConfig.services.prod,
			BEFFE_GRAPHQL_URL: 'https://www.lovet.com/api/bff',
			APPLE_APP_ID: '6478598865',
			ANDROID_APP_PACKAGE: 'com.teamtag.lovet',
		},
		nonprod: {
			...BaseBrandThemeConfig.services.nonprod,
			BEFFE_GRAPHQL_URL: 'https://wwwstg.lovet.com/api/bff',
		},
	},
	siteURL: 'https://www.lovet.com',
	features: {
		redirects: [],
		rewrite: {},
		favIcons: {},
		analytics: {
			enabled: true,
			vwoAccountId: '680759',
			gtmId: process?.env?.GTM_ANALYTICS_CONTAINER_ID ?? '',
		},
		sentry: {
			enabled: true,
		},
		chat: {
			enabled: false,
		},
		revSpringChat: {
			enabled: false,
		},
		notFoundPage: {
			desktopBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/43nx2LBlUqXh5SYykNrrdt/b4bfc78ca440010d28956374efc0c4eb/404_Background_1440x720px.jpg?q=90&fit=fill&f=face&fm=webp',
			mobileBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/6cBfghx5XgsYx19QW16CjU/e3a8cf8bd163d7b3b18e8ecc96c16c25/404_Background-Mobile_375x812.jpg?q=90&fit=fill&f=face&fm=webp',
		},
		livePreview: {
			local: 'https://local.lovet.com:8443',
			stage: 'https://wwwstg.lovet.com',
			prod: 'https://www.lovet.com',
		},
		footer: {
			lite: false,
			alt: false,
			withSimpleLayout: true,
		},
		blogs: {
			root: '/blog/',
		},
		migration: {
			paths: [],
		},
		otherApps: {
			facilityDetailsBasePath: 'locations',
			schedulingPath: 'book-an-appointment',
		},
		salesforce: {
			enabled: false,
		},
		vetspire: {
			nonprod: 'https://api2.vetspire.com/graphql',
			prod: 'https://api2.vetspire.com/graphql',
		},
		logRocket: {
			projectId: 'b4yq4l/lovet',
		},
	},
	contentfulAppId: 'Lovet - Scheduling' as ContentfulAppId,
	themeId: 'lovet' as TagThemeType,
	themeColor: '#FFFFFF',
	bffBrandType: BffBrandType.Lovet,
	googleMapBusinessQuery: 'https://www.google.com/maps/search/?api=1&query=Lovet, [address]',
};

config.featureFlags.showMobileHeaderLocationBar = false;
config.featureFlags.useFacilityBeffeDataSource = true;

export default config;
